import type * as React from 'react';
import { getIntrinsicElementProps, SkeletonItem, slot } from '@fluentui/react-components';
import type { GroundingMenuItemSkeletonProps, GroundingMenuItemSkeletonState } from './GroundingMenuItemSkeleton.types';

// If you add JSX to this file, be sure to change the file type to .tsx

/**
 * Create the state required to render GroundingMenuItemSkeleton.
 *
 * The returned state can be modified with hooks such as useGroundingMenuItemSkeletonStyles_unstable,
 * before being passed to renderGroundingMenuItemSkeleton_unstable.
 *
 * @param props - props from this instance of GroundingMenuItemSkeleton
 * @param ref - reference to root HTMLElement of GroundingMenuItemSkeleton
 */
export const useGroundingMenuItemSkeleton_unstable = (
  props: GroundingMenuItemSkeletonProps,
  ref: React.Ref<HTMLDivElement>,
): GroundingMenuItemSkeletonState => {
  return {
    components: {
      root: 'div',
      avatar: SkeletonItem,
      primaryText: SkeletonItem,
      secondaryText: SkeletonItem,
    },
    root: slot.always(
      getIntrinsicElementProps('div', {
        ref,
        ...props,
      }),
      { elementType: 'div' },
    ),
    avatar: slot.optional(props.avatar, {
      defaultProps: { shape: 'circle', size: 32 },
      renderByDefault: true,
      elementType: SkeletonItem,
    }),
    primaryText: slot.optional(props.primaryText, {
      defaultProps: { size: 12 },
      renderByDefault: true,
      elementType: SkeletonItem,
    }),
    secondaryText: slot.optional(props.secondaryText, {
      defaultProps: { size: 12 },
      renderByDefault: true,
      elementType: SkeletonItem,
    }),
  };
};
